import { Upload } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useState, FC } from 'react';
import { FileDrop } from '../../../components';
import { useDropzone } from 'react-dropzone';
import { useSnackbar } from 'notistack';
import { uploadEditSalesToolsContractTemplate } from '../../../fetch';

interface IContractMangementUploadButtonProps {
  buildDocumentTypeId: number;
  fetchSalesToolsContractTemplates: () => void;
}

export const ContractMangementUploadButton: FC<IContractMangementUploadButtonProps> = ({
  buildDocumentTypeId,
  fetchSalesToolsContractTemplates
}) => {
  const [isUploading, setIsUploading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const {
    getRootProps,
    getInputProps,
    open,
    isFocused,
    isDragActive,
    isDragAccept,
    isDragReject,
    isFileDialogActive,
    fileRejections,
    rootRef,
    inputRef,
    acceptedFiles
  } = useDropzone({
    accept: {
      'application/pdf': ['.pdf']
    },
    useFsAccessApi: false,
    onDrop: async acceptedFiles => {
      if (acceptedFiles.length > 0) {
        const acceptedFile = acceptedFiles[0];
        try {
          const formData = new FormData();
          formData.append('TemplateFile', acceptedFile);
          setIsUploading(true);
          await uploadEditSalesToolsContractTemplate(buildDocumentTypeId, formData);
          fetchSalesToolsContractTemplates();
          enqueueSnackbar(`File uploaded!`, {
            variant: 'success'
          });
        } catch (error) {
          enqueueSnackbar(`Error uploading file, please try again`, {
            variant: 'error'
          });
        } finally {
          setIsUploading(false);
        }
      } else {
        enqueueSnackbar(`Invalid file type. Please upload one of these image types, .pdf.`, {
          variant: 'error'
        });
      }
    }
  });

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <FileDrop
        id="File-drop-contract-management"
        getRootProps={getRootProps}
        getInputProps={getInputProps}
        open={open}
        isFocused={isFocused}
        isDragActive={isDragActive}
        isDragAccept={isDragAccept}
        isDragReject={isDragReject}
        isFileDialogActive={isFileDialogActive}
        fileRejections={fileRejections}
        rootRef={rootRef}
        inputRef={inputRef}
        acceptedFiles={acceptedFiles}
        title=""
        dropzoneSx={{
          padding: `0 !important`,
          border: `0 !important`,
          boxShadow: `none !important`
        }}
      >
        <Typography variant="body1">
          <Box
            component="a"
            href="/#"
            id="upload-contract-management"
            sx={{
              color: theme =>
                isUploading ? theme.palette.grey[200] : theme.palette.secondary.main,
              textDecoration: 'none',
              pointerEvents: isUploading ? 'none' : 'auto'
            }}
            onClick={e => {
              e.preventDefault();
              // Manually open file dialog after preventing accordion action
              e.stopPropagation();
              open();
            }}
          >
            <Box display="flex" alignItems="center" component="span" gap={0.25}>
              <Upload />
              Upload
            </Box>
          </Box>
        </Typography>
      </FileDrop>
    </Box>
  );
};
